import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSmallAndLightweightProps } from './IconSmallAndLightweight.types'
import * as Styled from './styles/IconSmallAndLightweight.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSmallAndLightweight: FC<IconSmallAndLightweightProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSmallAndLightweightProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSmallAndLightweightProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M9.367 10.25c2.29-.348 6.117-1.602 8.133-6.043.559-1.23 1.293-1.707 2.082-1.707 0 0 1.918-.125 1.918 4.125 0 2.79-1.352 9.598-9.227 12.723M4.086 15.16 7.5 10.371M4.086 15.16s1.539 4.215 6.539 5.84'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M8 17.563s3.813 2.394 8.25 2.312m-8.75-6.25A21.666 21.666 0 0 0 10.031 8.5' vectorEffect='non-scaling-stroke' />
          <path d='M2.473 14.828c2.515.64 12.449 2.5 16.125-7.078' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSmallAndLightweight
